module.exports = __webpack_public_path__ + "static/media/skysportsracing.2aece267c14952ae09f59916bfe582bf.png";